import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Query, withApollo } from "react-apollo";
import { PRODUCTLIST, PRODUCTCATEGORY, PRODUCTFILTERMASTER, PRODUCTLISTSTATUSEDIT } from "../../graphql/query";

import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Product from "../../components/Products";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { ProductFilter } from "../../components";
import { NetworkContext } from "../../context/NetworkContext";
import { API_URL } from "../../config";

const ImportButton = () => {
  const fileInputRef = useRef(null);
  const silverFileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);
  const [silverImporting, setSilverImporting] = useState(false);
  const [importMsg, setImportMsg] = useState("");
  const [importError, setImportError] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [silverAnchorEl, setSilverAnchorEl] = useState(null);

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImporting(true);
    setImportMsg("");
    setImportError("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(API_URL + "/importproducts", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (response.ok) {
        setImportMsg(result.message || `Successfully imported ${result.total} products`);
      } else {
        setImportError(result.message || "Import failed");
      }
    } catch (err) {
      setImportError("Network error: " + err.message);
    }
    setImporting(false);
    fileInputRef.current.value = "";
  };

  const handleSampleDownload = () => {
    setAnchorEl(null);
    const link = document.createElement("a");
    link.href = "/sample/CVD_Website_Upload_Details.xlsx";
    link.download = "CVD_Website_Upload_Details.xlsx";
    link.click();
  };

  const handleSilverImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSilverImporting(true);
    setImportMsg("");
    setImportError("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(API_URL + "/importproducts", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (response.ok) {
        setImportMsg(result.message || `Successfully imported ${result.total} products`);
      } else {
        setImportError(result.message || "Import failed");
      }
    } catch (err) {
      setImportError("Network error: " + err.message);
    }
    setSilverImporting(false);
    silverFileInputRef.current.value = "";
  };

  const handleSilverSampleDownload = () => {
    setSilverAnchorEl(null);
    const link = document.createElement("a");
    link.href = "/sample/Silver_Website_Upload.xlsx";
    link.download = "Silver_Website_Upload.xlsx";
    link.click();
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls,.csv"
        onChange={handleImport}
      />
      <input
        type="file"
        ref={silverFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls,.csv"
        onChange={handleSilverImport}
      />
      <Button
        variant="outlined"
        color="primary"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={importing}
        style={{ marginRight: 10 }}
        endIcon={<ArrowDropDownIcon />}
      >
        {importing ? <><CircularProgress size={16} style={{ marginRight: 6 }} /> Importing...</> : "CVD Import"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => { setAnchorEl(null); fileInputRef.current.click(); }}>
          CVD Import
        </MenuItem>
        <MenuItem onClick={handleSampleDownload}>
          Sample
        </MenuItem>
      </Menu>
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => setSilverAnchorEl(e.currentTarget)}
        disabled={silverImporting}
        style={{ marginRight: 10 }}
        endIcon={<ArrowDropDownIcon />}
      >
        {silverImporting ? <><CircularProgress size={16} style={{ marginRight: 6 }} /> Importing...</> : "Silver Import"}
      </Button>
      <Menu
        anchorEl={silverAnchorEl}
        open={Boolean(silverAnchorEl)}
        onClose={() => setSilverAnchorEl(null)}
      >
        <MenuItem onClick={() => { setSilverAnchorEl(null); silverFileInputRef.current.click(); }}>
          Silver Import
        </MenuItem>
        <MenuItem onClick={handleSilverSampleDownload}>
          Sample
        </MenuItem>
      </Menu>
      <Backdrop open={importing || silverImporting} style={{ zIndex: 1300, color: "#fff", flexDirection: "column" }}>
        <CircularProgress color="inherit" size={50} />
        <Typography style={{ marginTop: 16, color: "#fff" }}>Importing products, please wait...</Typography>
      </Backdrop>
      <Snackbar open={!!importMsg} autoHideDuration={8000} onClose={() => setImportMsg("")}>
        <Alert onClose={() => setImportMsg("")} severity="success">{importMsg}</Alert>
      </Snackbar>
      <Snackbar open={!!importError} autoHideDuration={8000} onClose={() => setImportError("")}>
        <Alert onClose={() => setImportError("")} severity="error">{importError}</Alert>
      </Snackbar>
    </>
  );
};

export const Productlist = withRouter(
  withApollo((props) => {
    const [masters, setMasters] = useState({});
    const [filterparams, setFilterparams] = useState({});

    function onFilter(filterobj) {
      let filtercontent = {};

      if (filterobj.product_category) {
        filtercontent["categoryname"] = filterobj.product_category.name;
      }
      if (filterobj.product_type) {
        filtercontent["product_type"] = filterobj.product_type.name;
      }
      if (filterobj.cvd) {
        filtercontent["cvd"] = filterobj.cvd.value;
      }
      setFilterparams(filtercontent);
    }
    function onSearch(searchtext) {
      //  alert(searchtext)
      setFilterparams({
        ...filterparams,
        searchtext,
      });
      // fetchadminusers()
    }

    useEffect(() => {
      const query = props.client.query;
      query({
        query: PRODUCTFILTERMASTER,
        fetchPolicy: "network-only",
      })
        .then((data) => {
          if (data) {
            let product_categories = data.data.allMasterProductCategories.nodes;
            let product_types = data.data.allMasterProductTypes.nodes;
            setMasters({
              product_categories,
              product_types,
            });
          } else {
          }
        })
        .catch((error) => {
          console.log("smbcj");
        });
    }, []);

    return (
      <Grid container spacing={2}>
        <Grid container item xs={12} sm={12} alignItems={"flex-end"}>
          <Grid fullwidth item xs={6} sm={6}>
            <Typography component="h6" variant="h6">
              Products
            </Typography>
          </Grid>

          <Grid fullwidth item xs={6} sm={6} style={{ "text-align": "right" }}>
            <ImportButton />
            <Link underline="none" component={RouterLink} to={"/productupload"}>
              <Button variant="contained" color="primary">
                Add New Product
              </Button>
            </Link>
          </Grid>
        </Grid>
        <ProductFilter masters={masters} onSearch={onSearch} onFilter={onFilter} />
        <Product filterparams={filterparams} />
      </Grid>
    );
  })
);

export default Productlist;
